import { render, staticRenderFns } from "./create_expected_student_file.vue?vue&type=template&id=07b6a194&scoped=true&"
import script from "./create_expected_student_file.vue?vue&type=script&lang=ts&"
export * from "./create_expected_student_file.vue?vue&type=script&lang=ts&"
import style0 from "./create_expected_student_file.vue?vue&type=style&index=0&id=07b6a194&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b6a194",
  null
  
)

export default component.exports